/**
 * @generated SignedSource<<0acb0ef99f17f997b676025ef1c57b1b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectInvoicingTableSection_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"InvoiceFilterButton_viewer">;
  readonly " $fragmentType": "ProjectInvoicingTableSection_viewer";
};
export type ProjectInvoicingTableSection_viewer$key = {
  readonly " $data"?: ProjectInvoicingTableSection_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectInvoicingTableSection_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectInvoicingTableSection_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InvoiceFilterButton_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "16c70b4d8388537ee07f5990b272d857";

export default node;
